const isHTTPS = window.location.protocol === "https:";

import audioFile from '../assets/audio/notify.wav';
import icon from '../assets/img/BeOn.png';
import {notificationCommentAddLocalRequest} from "../store/actions/notification.js";
import Api from "../Api.js";
import {REACT_SOCKET_URL} from '../config.js'
const chatSockets = {}; // 👈 Hold socket connections per chat
const reconnectTimeouts = {}; // 👈 Reconnect timers per chat

const playNotificationSound = () => {
    const audio = new Audio(audioFile);
    audio.play().catch((error) => console.error("🔇 Error playing sound:", error));
};

const showBrowserNotification = (data) => {
    if (document.hidden && Notification.permission === "granted") {
        new Notification(`💬 New message from ${data.sender || "Chat"}`, {
            body: data.message,
            icon: icon,
        });
    }
};

export const connectChatSocket = (chatId, token, dispatch, userId) => {
    const WS_URL = `${REACT_SOCKET_URL}/ws/chat/${chatId}/?token=${token}`;

    if (chatSockets[chatId]) {
        console.log(`🔌 Already connected to chat ${chatId}`);
        return;
    }

    const socket = new WebSocket(WS_URL);
    chatSockets[chatId] = socket;

    socket.onopen = () => {
        console.log(`✅ Connected to chat ${chatId}`);
        if (reconnectTimeouts[chatId]) {
            clearTimeout(reconnectTimeouts[chatId]);
            reconnectTimeouts[chatId] = null;
        }
    };

    socket.onmessage = async (event) => {
        const data = JSON.parse(event.data);
        const isNotFromSelf = data.sender_id !== userId;

        const res = await Api.getNotificationSingle(chatId);
        dispatch(notificationCommentAddLocalRequest(res.data))

        if (isNotFromSelf) {
            playNotificationSound();
            showBrowserNotification(data);
        }

        console.log(`📨 Message from chat ${chatId}:`, data);
    };

    socket.onclose = () => {
        console.warn(`⚠️ Chat ${chatId} disconnected`);
        reconnectChatSocket(chatId, token, dispatch, userId);
    };

    socket.onerror = (error) => {
        console.error(`❌ WebSocket error in chat ${chatId}:`, error);
        socket.close();
    };
};

export const reconnectChatSocket = (chatId, token, dispatch, userId) => {
    if (!reconnectTimeouts[chatId]) {
        reconnectTimeouts[chatId] = setTimeout(() => {
            console.log(`♻️ Reconnecting to chat ${chatId}`);
            connectChatSocket(chatId, token, dispatch, userId);
        }, 3000);
    }
};

export const disconnectChatSocket = (chatId) => {
    const socket = chatSockets[chatId];
    if (socket) {
        socket.onopen = null;
        socket.onclose = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.close();
        delete chatSockets[chatId];
        console.log(`❌ Disconnected chat socket ${chatId}`);
    }
};

export const sendChatMessage = (chatId, message, sender) => {
    const socket = chatSockets[chatId];
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ message, sender }));
    } else {
        console.warn(`⚠️ Cannot send message — socket not open for chat ${chatId}`);
    }
};
